import {LocationInformation} from 'molbio/components/SaveLocationPicker';
import {WorklistFormType} from 'worklists/WorklistConstants';

/**
 * Given a LocationInformation and a display string for an entity potentially being saved, get error messages.
 * @param locationInfo Information about where to save entities and whether to add them to a worklist.
 * @param displayString The type of entity being saved, e.g. 'fragments', 'constructs', or 'primers'.
 */
export function getLocationInfoErrors({
  locationInfo,
  displayString,
}: {
  locationInfo: LocationInformation;
  displayString: string;
}): Array<string> {
  const errors = [];
  const {targetFolderId, worklistParams} = locationInfo;
  if (targetFolderId == null) {
    errors.push(`A folder for ${displayString} is required.`);
  }
  if (worklistParams?.worklistFormType === WorklistFormType.NEW) {
    if (worklistParams?.newWorklistInfo?.name === '' || worklistParams.newWorklistInfo?.name == null) {
      errors.push(`A worklist name for ${displayString} is required.`);
    }
    if (worklistParams?.targetWorklistId != null) {
      errors.push(`Cannot add ${displayString} to both an existing worklist and a new worklist.`);
    }
  } else if (worklistParams?.worklistFormType === WorklistFormType.EXISTING) {
    if (worklistParams?.newWorklistInfo != null) {
      errors.push(`Cannot add ${displayString} to both an existing worklist and a new worklist.`);
    }
    if (worklistParams?.targetWorklistId == null) {
      errors.push(`A worklist for ${displayString} is required.`);
    }
  }
  return errors;
}
